import { call, put, takeLatest, select, take } from 'redux-saga/effects';
import { bookletApi, shareApi } from '../services';

import {
  LOADING_ROUTE_START,
  LOADING_ROUTE_FINISHED,
  LOADING_DATA_START,
  LOADING_DATA_FINISHED,
} from '../reducers/loading.reducer';

import {
  BOOKLET_FETCH,
  BOOKLET_FETCH_SUCCESS,
  BOOKLET_FETCH_FAILURE,
  BOOKLET_SAVE,
  BOOKLET_SAVE_SUCCESS,
  BOOKLET_PRINT,
  BOOKLET_SET_IMAGES_COUNT,
  BOOKLET_SHARED_FETCH,
  BOOKLET_SHARED_FETCH_SUCCESS,
  BOOKLET_SHARED_FETCH_FAILURE,
  BOOKLET_REMOVE_HERO_IMAGE,
  BOOKLET_REMOVE_HERO_IMAGE_FAILURE,
  BOOKLET_REMOVE_HERO_IMAGE_SUCCESS,
  BOOKLET_CREATE_NEW_BOOKLET,
} from '../reducers/booklet.reducer';
import { handleError } from './helper';
import { showNotification } from '../helpers/notification';

const getImagesCount = state => {
  const {
    booklet: { imagesCount },
  } = state;
  return imagesCount;
};

const getHeroImage = state => {
  const {
    booklet: { heroImage },
  } = state;
  return heroImage;
};

function* createNewBookletRequest({ payload: { booklet, returnToFirstStep } }) {
  try {
    yield put({ type: LOADING_DATA_START });

    delete booklet.sections;
    delete booklet.name;

    if (booklet.heroImage && !booklet.heroImage.url) {
      delete booklet.heroImage;
    }

    const { data } = yield call(bookletApi.createNewBooklet, { booklet });
    yield put({ type: BOOKLET_SAVE_SUCCESS, payload: { ...data } });
  } catch (error) {
    returnToFirstStep();
    const message = yield* handleError(error, 'Booklet save failed.');
    showNotification(message);
  }

  yield put({ type: LOADING_DATA_FINISHED });
}

function* saveBookletRequest({ payload: { booklet } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    if (booklet.heroImage && !booklet.heroImage.url) {
      delete booklet.heroImage;
    }

    delete booklet.name;

    const { data } = yield call(bookletApi.editBooklet, { booklet });
    yield put({ type: BOOKLET_SAVE_SUCCESS, payload: { ...data } });
  } catch (error) {
    const message = yield* handleError(error, 'Booklet save failed.');
    showNotification(message);
  }

  yield put({ type: LOADING_DATA_FINISHED });
}

function* fetchBookletRequest({ payload: { id } }) {
  try {
    yield put({ type: LOADING_ROUTE_START });

    const { data } = yield call(bookletApi.fetchBooklet, { id });

    yield put({ type: LOADING_ROUTE_FINISHED });
    yield put({ type: BOOKLET_FETCH_SUCCESS, payload: data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: BOOKLET_FETCH_FAILURE, payload: message });
  }
}

function* fetchBookletSharedRequest({ payload: { token } }) {
  try {
    yield put({ type: LOADING_ROUTE_START });

    const {
      data: { booklet, email },
    } = yield call(shareApi.fetchBookletShared, { token });

    yield put({ type: LOADING_ROUTE_FINISHED });
    yield put({
      type: BOOKLET_SHARED_FETCH_SUCCESS,
      payload: { ...booklet, share: { email }, token },
    });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: BOOKLET_SHARED_FETCH_FAILURE, payload: message });
  }
}

function* removeBookletHeroImageRequest({ payload }) {
  let heroImage = yield select(getHeroImage);

  try {
    yield put({ type: BOOKLET_REMOVE_HERO_IMAGE_SUCCESS });
    yield call(bookletApi.removeBookletApi, payload);
  } catch (error) {
    yield put({ type: BOOKLET_REMOVE_HERO_IMAGE_FAILURE, payload: heroImage });
  }
}

function* watchPrintBooklet() {
  try {
    let imagesCount = yield select(getImagesCount);

    while (imagesCount > 0) {
      yield take(BOOKLET_SET_IMAGES_COUNT);
      imagesCount = yield select(getImagesCount);
    }
    window.print();
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: BOOKLET_FETCH_FAILURE, payload: message });
  }
}

export function* fetchBooklet() {
  yield takeLatest(BOOKLET_FETCH, fetchBookletRequest);
}

export function* removeBookletHeroImage() {
  yield takeLatest(BOOKLET_REMOVE_HERO_IMAGE, removeBookletHeroImageRequest);
}

export function* fetchBookletShared() {
  yield takeLatest(BOOKLET_SHARED_FETCH, fetchBookletSharedRequest);
}

export function* saveBooklet() {
  yield takeLatest(BOOKLET_SAVE, saveBookletRequest);
}

export function* createNewBooklet() {
  yield takeLatest(BOOKLET_CREATE_NEW_BOOKLET, createNewBookletRequest);
}

export function* printBooklet() {
  yield takeLatest(BOOKLET_PRINT, watchPrintBooklet);
}



// WEBPACK FOOTER //
// ./src/sagas/booklet.saga.js